/**
 * This page only exists to support bumble.com/the-buzz (without languge in URL)
 */
export { default, getServerSideProps } from "pages/[lang]/index-lang";
